var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.numberOption.ShowNumber
    ? _c("div", { staticClass: "number-wrap mr-3" }, [
        _c("span", [
          _vm.numberOption.SkinCode
            ? _c(
                "svg",
                {
                  staticClass: "position-absolute",
                  staticStyle: { opacity: "0", "z-index": "-1" },
                },
                [
                  _c("defs", [
                    _c("clipPath", {
                      style: { transform: "scale(0.01)" },
                      attrs: {
                        id: `maskImage-numberPack-${_vm.elementId}`,
                        clipPathUnits: "objectBoundingBox",
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.numberOption.SkinCode),
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            staticClass: "d-flex align-items-center justify-content-center",
            style: _vm.numberStyle,
          },
          [_c("span", [_vm._v(" " + _vm._s(_vm.numberOption.Text))])]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }